import axios from "axios";
import { getAccessToken } from "../utils/Util";
import { RequestOTPType, UuidParamType } from "../utils/KType";
import { URL_END_POINT } from "../utils/Constant";
// Axios request interceptor to add Authorization header
const setAxiosInterceptors = (axiosInstance: any) => {
  axiosInstance.interceptors.request.use(
    (config: any) => {
      const token = getAccessToken();
      if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error: any) => Promise.reject(error)
  );
};
export const getAxiosInstance = () => {
  const axiosInstance = axios.create();
  setAxiosInterceptors(axiosInstance);
  return axiosInstance;
};
export const generateMessage = async (previousMessage: any) => {
  try {
    const response = await getAxiosInstance().post(
      `${process.env.REACT_APP_API_BASE_URL}/generate`,
      previousMessage
    );
    return response;
  } catch (error) {
    console.log("error", error);
    return error;
  }
};
//Function for streaming messages
export const generateMessageStream = async (
  payload: any,
  onToken: (token: string) => void,
  onDone: () => void,
  onError: (err: any) => void
) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/generate-stream`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload), // ✅ SAME payload
      }
    );
    if (!response.ok) {
      let errorPayload: any = null;
      try {
        errorPayload = await response.json();
      } catch {
        errorPayload = { message: "Unknown error" };
      }
      onError(errorPayload);
      return; // ⛔ DO NOT continue streaming
    }

    const contentType = response.headers.get("content-type") || "";
    if (!contentType.includes("text/event-stream")) {
      const text = await response.text();
      onError({ message: text });
      return;
    }
    // ✅ SAFETY CHECK for TypeScript + runtime
    if (!response.body) {
      onError({ message: "Streaming not supported by browser / empty body" });
      return;
    }
    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      // SSE messages are separated by \n\n
      const parts = buffer.split("\n\n");
      buffer = parts.pop() || "";
      for (const part of parts) {
        if (part.startsWith("data:")) {

          //const token = part.replace(/^data:/, "");

          let payload: any;
          try {
            payload = JSON.parse(part.replace(/^data:/, ""));
          } catch (parseErr) {
            console.warn("Skipping malformed SSE frame:", part, parseErr);
            continue;
          }

            const token = payload.token;


          // Skip empty keep-alive pings and the end-of-stream sentinel,
          // but keep whitespace-only tokens (" ", "\n") — they are real content.
          if (token === "") continue;
          if (token.trim() === "[DONE]") continue;
          onToken(token); // ✅ STREAM token (raw, untrimmed)
        }
      }
    }
    onDone();
  } catch (err) {
    console.error("SSE error:", err);
    onError(err);
  }
};
// Function to get UUID using a token
export const fetchUuid = async (token: string, params: UuidParamType) => {
  try {
    const response = await getAxiosInstance().get(
      `${process.env.REACT_APP_API_BASE_URL}/get_uuid`,
      {
        params,
      }
    );
    return response.data.uuid;
  } catch (error) {
    console.error("Error fetching UUID:", error);
    throw error;
  }
};
export const getAllData = async (token: string, email: string) => {
  try {
    const params: UuidParamType = {
      email_id: email,
      trace_id: "",
      span_id: "",
    };
    const uuid = await fetchUuid(token, params);
    return { uuid };
  } catch (error) {
    throw error;
  }
};
// Function to request otp
export const getOTP = async (data: RequestOTPType) => {
  try {
    const response = await getAxiosInstance().post(
      `${process.env.REACT_APP_OTP_BASE_URL}${URL_END_POINT.OPT_SEND}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching otp:", error);
    return null;
  }
};
export const verifyOTP = async (data: any) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_AUTH_MANAGEMENT_BASE_URL}${URL_END_POINT.VERIFY_OTP}`,
      data,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching otp:", error);
    return null;
  }
};
/**
 * This method is called after get OTP request for login.
 * challenge is generated using  verifier. The same verifier is used for OTP Verification.
 * Please check method generatePKCEParams.
 * API gives code, that is used for OTP verification.
 * @param data
 * @returns
 */
export const getCodeId = async (data: any) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_AUTH_MANAGEMENT_BASE_URL}${URL_END_POINT.GET_CODE_ID}`,
      data,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching code id:", error);
    return null;
  }
};
export const authenticateAfterOTPValidation = async (data: any) => {
  try {
    const response = await getAxiosInstance().post(
      `${process.env.REACT_APP_API_BASE_URL}${URL_END_POINT.AUTHENTICATE}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error while authenticating", error);
    return null;
  }
};